import { useState, useRef, useMemo, useCallback, useEffect } from "react"
import { SimpleHttp } from "src/lib/utils/SimpleHTTP";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";
import { toast } from "react-toastify";
import { StepStyleSection } from "../../layout";

import { CheckboxItem } from "../../components/check/checkbox";
import useGetSpecialties from "src/hooks/useGetSpecialtyBasedOnStack";
import useGetAllSpecialties from "../../../../../hooks/useGetSpecialties";



export default function NewSpecialty({ isNested }) {
  const { userLanguages, updateUserLanguages, userStack, updateUserStack } = useClientSignUpSteps();
  const [newSTack, setNewStack] = useState('')
  const [localValue, setLocalValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const noResultsTimer = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const containerRef = useRef(null);
  const maxSelection = 1;


  const { loading, error, specialties, retry } = useGetSpecialties(userStack);

  const { loading: loadingAll, error: errorAll, specialties: specialtiesAll, retry: retryAll } = useGetAllSpecialties();




  const userLangNames = useMemo(
    () => specialtiesAll.map((l) => l.name),
    [specialtiesAll]
  );


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (noResultsTimer.current) {
        clearTimeout(noResultsTimer.current);
        noResultsTimer.current = null;
      }
    };
  }, []);




  useEffect(() => {
    const hasData = userLangNames && userLangNames.length > 0;
    setSuggestions(hasData ? userLangNames : []);
    // setShowSuggestions(hasData);
    if (localValue.trim().length > 0) {
  setShowSuggestions(hasData);
}
    setNoResults(false);
  }, [userLangNames]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setLocalValue(value);

    if (noResultsTimer.current) {
      clearTimeout(noResultsTimer.current);
      noResultsTimer.current = null;
    }
    setNoResults(false);

    if (value.trim()) {

      if (loadingAll || userLangNames.length === 0) {
        setSuggestions([]);
        setShowSuggestions(false);
        return;
      }

      const filtered = userLangNames.filter((lang) =>
        lang.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
      setShowSuggestions(true);

      if (filtered.length === 0) {
        noResultsTimer.current = setTimeout(() => {
          setNoResults(true);
        }, 1500);
      }
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

const handleSelectSuggestion = async (specialty) => {
    if (userLanguages.length >= maxSelection) {
      toast.info("You have selected maximum number of Specialties");
      setShowSuggestions(false);
      return;
    }

    const alreadyExists = userLanguages.some((l) => l.name.toLowerCase() === specialty.toLowerCase());
    if (alreadyExists) {
      toast.info("This specialty is already added");
      setShowSuggestions(false);
      return;
    }

    const matchedSpecialty = specialtiesAll.find(
      (s) => s.name.toLowerCase() === specialty.toLowerCase()
    );

    if (!matchedSpecialty) {
      toast.error("Specialty not found");
      return;
    }

    updateUserLanguages([
      ...userLanguages,
      {
        id: matchedSpecialty.id,
        name: matchedSpecialty.name,
        experience: undefined,
      },
    ]);

    setLocalValue("");
    setShowSuggestions(false);

    try {
      const { status, data, error } = await SimpleHttp.getNoAuth(`/api/v1/all/nontech/getLanguageBasedOnStack/${matchedSpecialty.id}`);
      if (status === true) {
        updateUserStack(data.name);  
      } else {
        console.log("Stack fetch error:", error);
      }
    } catch (err) {
      console.log("Stack fetch exception:", err);
    }
  };

  const handleConfirmOther = () => {
    if (localValue.trim()) {
      if (userLanguages.length >= maxSelection) {
        toast.info("You have selected maximum number of Specialties");
        return;
      }
      const alreadyExists = userLanguages.some(
        (l) => l.name.toLowerCase() === localValue.trim().toLowerCase()
      );
      if (alreadyExists) {
        toast.info("This specialty is already added");
        return;
      }


    

      updateUserLanguages([
        ...userLanguages,
        {
          id: `custom-${Date.now()}`,
          name: localValue.trim(),
          experience: undefined,
        },
      ]);
      setLocalValue("");
      setShowSuggestions(false);
    }
  };

  const innerContent = (
      <div ref={containerRef} className="mt-2 animate-in fade-in slide-in-from-top-1 duration-300 relative">
        {!isNested && (
          <div className="flex w-full items-center justify-between gap-4 pb-3 py-1">
            <p className="text-semibold">Select Specialty</p>
            <div className="text-xs text-bold px-2 py-1 rounded-lg">
              {userLanguages.length} / {maxSelection}
            </div>
          </div>
        )}

   <div className="p-3 mb-3 inline-flex flex-col gap-1">
  {userLanguages.map((customLang) => (
    <CheckboxItem
      key={customLang.id}
      selected={true}
      onSelect={() => updateUserLanguages(userLanguages.filter((each) => each.id !== customLang.id))}
    >
      {customLang.name}
    </CheckboxItem>
  ))}
</div>

        <div className="relative">
          <input
            type="text"
            placeholder="Type specialty and press Enter"
            className="w-full p-3 rounded-xl border-2 border-primary/20 focus:border-primary outline-none transition-all bg-white shadow-sm"
            value={localValue}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleConfirmOther();
              }
            }}
         
          />
          {/* Suggestions Dropdown */}
          {showSuggestions && (
            <div className="absolute z-50 w-full mt-2 bg-white border border-gray-100 rounded-xl shadow-xl overflow-hidden">
              {loadingAll ? (
                <div className="p-4 text-muted-foreground text-center">Loading...</div>
              ) : suggestions.length > 0 ? (
                <div className="max-h-60 overflow-y-auto">
                  {suggestions.map((spec, index) => (
                    <button
                      key={index}
                      onClick={() => handleSelectSuggestion(spec)}
                      className="w-full text-left px-4 py-3 text-sm hover:bg-primary/5 transition-colors border-b border-gray-50 last:border-0 group flex items-center justify-between"
                    >
                      <span className="font-medium text-gray-700 group-hover:text-primary">{spec}</span>
                      <span className="text-[10px] text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity">Add</span>
                    </button>
                  ))}
                </div>
              ) : (
                <div className="p-4 text-muted-foreground text-center">No specialties found</div>
              )}
            </div>
          )}
        </div>
      </div>
  );

  return isNested ? innerContent : <StepStyleSection>{innerContent}</StepStyleSection>;
}